// extracted by mini-css-extract-plugin
export var label = "_5k-1";
export var reminder = "_5k-0";